export default "__VITE_ASSET__B_6jiIKQ__"